import type { IWarehouseConfigService } from './IWarehouseConfigService';
import type { ApiConfiguration } from './dto/ApiConfiguration.dto';
import type { ApiUpdateConfigurationRequest } from './dto/ApiUpdateConfigurationRequest.dto';
import { fetchWithAuth } from '../../utils/fetch/FetchWithAuth';

const BASE_URL = '/api/warehouse/configuration';

export class WarehouseConfigService implements IWarehouseConfigService {
    async get(): Promise<ApiConfiguration> {
        return fetchWithAuth(BASE_URL, {
            method: 'GET',
        }) as Promise<ApiConfiguration>;
    }

    async save(payload: ApiUpdateConfigurationRequest): Promise<ApiConfiguration> {
        return fetchWithAuth(BASE_URL, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
        }) as Promise<ApiConfiguration>;
    }
}